import { LogMetadataConfiguration } from "./log-reporter-service-models";

let logMasterDataCache: any[] = [];

export function setLogMasterData(masterData: any[] | null | undefined): void {
    logMasterDataCache = [...(masterData ?? [])];
}

export function getLogMasterData(): any[] {
    return [...logMasterDataCache];
}

export function findLogMasterData(
    category: string,
    keyName: string,
    masters: any[] = getLogMasterData()
): any | undefined {
    const normalizedCategory = category.trim().toLowerCase();
    const normalizedKeyName = keyName.trim().toLowerCase();

    return masters.find(master =>
        master?.category?.trim?.().toLowerCase?.() === normalizedCategory
        && master?.keyName?.trim?.().toLowerCase?.() === normalizedKeyName
    );
}

export function getLogMasterDataByCategory(
    category: string,
    masters: any[] = getLogMasterData()
): any[] {
    const normalizedCategory = category.trim().toLowerCase();

    return masters.filter(master => master?.category?.trim?.().toLowerCase?.() === normalizedCategory);
}

export function buildLogMetadataConfigurationFromMasterData(
    masters: any[] = getLogMasterData()
): LogMetadataConfiguration {
    return {
        environments: [],
        logSources: getLogMasterDataByCategory('Source', masters),
        loggers: getLogMasterDataByCategory('Logger', masters),
        logLevels: getLogMasterDataByCategory('LogLevel', masters),
    };
}
